import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface UiState {
  sidebarCollapsed: boolean;
  isMobileSidebarOpen: boolean;
  pageTitle: string;
  finaceYear: number;
  isYearChanging: boolean; // Add loading state for year changes
}

const initialState: UiState = {
  sidebarCollapsed: false,
  isMobileSidebarOpen: false,
  pageTitle: 'Dashboard',
  finaceYear: 2024,
  isYearChanging: false,
};

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar: (state) => {
      state.sidebarCollapsed = !state.sidebarCollapsed;
    },
    setSidebarCollapsed: (state, action: PayloadAction<boolean>) => {
      state.sidebarCollapsed = action.payload;
    },
    toggleMobileSidebar: (state) => {
      state.isMobileSidebarOpen = !state.isMobileSidebarOpen;
    },
    setMobileSidebarOpen: (state, action: PayloadAction<boolean>) => {
      state.isMobileSidebarOpen = action.payload;
    },
    setPageTitle: (state, action: PayloadAction<string>) => {
      state.pageTitle = action.payload;
    },
    setFinaceYear: (state, action: PayloadAction<number>) => {
      state.finaceYear = action.payload;
    },
    // New action for year change with loading state
    startYearChange: (state) => {
      state.isYearChanging = true;
    },
    completeYearChange: (state) => {
      state.isYearChanging = false;
    },
  },
});

export const {
  toggleSidebar,
  setSidebarCollapsed,
  toggleMobileSidebar,
  setMobileSidebarOpen,
  setPageTitle,
  setFinaceYear,
  startYearChange,
  completeYearChange,
} = uiSlice.actions;

export default uiSlice.reducer;
